import { closeSnackbar, enqueueSnackbar, type SnackbarKey } from "notistack";
import { createElement } from "react";

interface ShowToastOptions {
  autoHideDurationInMilliseconds?: number;
}

function preserveNewlines(message: React.ReactNode): React.ReactNode {
  // Wrap plain-string messages so embedded `\n` characters render as line
  // breaks. Non-string nodes are passed through untouched.
  if (typeof message !== "string") {
    return message;
  }
  return createElement("span", { style: { whiteSpace: "pre-line" } }, message);
}

export function showSuccessToast(message: React.ReactNode, options?: ShowToastOptions) {
  const { autoHideDurationInMilliseconds } = options ?? {};

  return enqueueSnackbar({
    message: preserveNewlines(message),
    variant: "success",
    autoHideDuration: autoHideDurationInMilliseconds,
  });
}

export function showInfoToast(message: string, options?: ShowToastOptions) {
  const { autoHideDurationInMilliseconds } = options ?? {};

  return enqueueSnackbar({
    message,
    variant: "info",
    autoHideDuration: autoHideDurationInMilliseconds,
  });
}

export function showErrorToast(message: React.ReactNode, options?: ShowToastOptions) {
  const { autoHideDurationInMilliseconds } = options ?? {};

  return enqueueSnackbar({
    message: preserveNewlines(message),
    variant: "error",
    autoHideDuration: autoHideDurationInMilliseconds,
  });
}

export function showWarningToast(message: string, options?: ShowToastOptions) {
  const { autoHideDurationInMilliseconds } = options ?? {};

  return enqueueSnackbar({
    message,
    variant: "warning",
    autoHideDuration: autoHideDurationInMilliseconds,
  });
}

export function closeToast(toastKey: SnackbarKey) {
  closeSnackbar(toastKey);
}
